module.exports = __webpack_public_path__ + "static/service01-b7b9e52ec7465cc3e6fb844c787187d6.png";